<template>
  <div class="spelling-list-scroller"
       :style="{'height': organizers.length === 1?'4.95rem':'9.9rem'}">
    <div :style="{'transform': `translateY(-${currentOffset}rem)`}"
         :class="{'scroller':organizers.length > 2 && currentOffset}">
      <groupRow v-for="item in computedOrganizers"
                :key="item && item.id"
                :organizer="item">
      </groupRow>
    </div>
  </div>
</template>
<script>
import groupRow from './groupRow.vue'
import { setTimeout } from 'timers'
// 12个一组
// height:5rem
const ROW_HEIGHT = 5
const DELAY = 2222
export default {
  components: {
    groupRow
  },
  props: ['organizers'],
  data() {
    return {
      computedOrganizers: [],
      currentOffset: 0,
      setTimeoutId: 0,
      totleHeight: 0
    }
  },
  created() {
    this.init(this.organizers)
  },
  watch: {
    organizers(newVal) {
      this.init(newVal)
    }
  },
  methods: {
    init(newVal) {
      window.clearTimeout(this.setTimeoutId)
      this.currentOffset = 0
      if (!newVal.length || newVal.length <= 2) {
        this.computedOrganizers = newVal || []
        return
      }
      let computedOrganizers = (newVal.length % 2 === 0 ? newVal : newVal.concat(newVal))
      this.computedOrganizers = [...computedOrganizers, ...newVal.slice(0, 2)]
      this.totleHeight = this.computedOrganizers.length * ROW_HEIGHT
      setTimeout(() => {
        this.transfromY()
      }, DELAY * 2)
    },
    transfromY() {
      let currentOffset = this.currentOffset += 2 * ROW_HEIGHT
      if (currentOffset >= this.totleHeight) {
        this.currentOffset = 0
      } else {
        this.currentOffset = currentOffset
      }
      let delay = this.currentOffset === 0 || this.currentOffset === this.totleHeight - 2 * ROW_HEIGHT ? DELAY : DELAY * 2
      this.setTimeoutId = setTimeout(() => {
        this.transfromY()
      }, delay)
    }
  },
  beforeDestory() {
    window.clearTimeout(this.setTimeoutId)
  },
}
</script>
<style lang="less">
.spelling-list-scroller {
  padding: 0 1.06rem;
  overflow: hidden;
  .scroller {
    transition: transform 0.5s;
  }
}
</style>
